<div
    [ngClass]="{
        'row d-flex justify-content-center stepper-top g-0': !stepper?.currentStepConfig?.isStandaloneStep
    }"
>
    <zci-stepper #stepper [flow]="flowKey"></zci-stepper>
</div>
